<template>
  <div class="d-flex flex-column fv-row">
    <label v-if="label" class="dm-fs-0-9-rem fw-bold form-label text-ellipsis" :title="label" :class="{required_star: required}" :for="name"
    >
      <slot name="labelText">{{ label }}</slot>
    </label>
    <div :class="{'d-flex align-items-center position-relative my-1': debounce}">
      <textarea v-if="type === 'textarea'" class="form-control form-control-solid mb-3"
                :class="{ 'is-invalid': form.errors.has(name) }"
                :id="name"
                rows="5"
                :value="value"
                @input="emitValue($event.target.value)"
                :placeholder="placeholder"
                :disabled="disabled"></textarea>
      <input
          @focus="mouseEnter"
          v-else
          :type="type"
          class="form-control form-control-sm form-control-solid mb-3"
          :class="{ 'is-invalid': form.errors.has(name), 'pe-14': debounce, }"
          :id="name"
          :value="value"
          @input="emitValue($event.target.value)"
          @keyup="searchDebounced"
          :placeholder="placeholder"
          :disabled="disabled"
      />
      <span v-show="searching" class="end-0 me-3 mb-3 position-absolute svg-icon svg-icon-1"><i
          class="fa fa-2x fa-circle-notch fa-pulse text-primary"></i></span>
    </div>

    <has-error :form="form" :field="name"></has-error>
    <div ref="tooltipx" v-if="debounce && duplicates.length" v-show="mouseOn" class="tooltipx" tabindex="-1" @focusout="mouseLeave" style="left:0px">
      <div class="tooltiptext bg-dark text-white p-2">
        <div class="row">
          <div class="col-md-9">
            <div class="p-2">
              <b>Possible Duplicates</b>
            </div>
          </div>
          <div class="col-md-3">
            <div class="btn btn-sm btn-icon btn-active-color-primary justify-content-end" @click="mouseLeave" style="float:right"><span class="svg-icon svg-icon-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect><rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect></svg></span></div>
          </div>
        </div>
        <hr width="100%" style="margin-top:0;">
        <div :key="`dupl--${d.id}`" v-for="d in duplicates" class="duplicates">
        {{ d[debounceSettings.label] }}
        <router-link :to="{name: debounceSettings.route_name, params: {id: d.company?d.company:d.id, module: $module}}" v-show="debounceSettings.route_name" target="_blank" style="float:right">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-right" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z"/> </svg>
          </router-link>
          <hr width="100%">
        </div>

      </div>
    </div>
  </div>
</template>
<style scoped>
  .tooltipx .tooltiptext {
    width: 100% !important;
  }
  .tooltipx .tooltiptext::after {
    left: 4% !important;
  }
</style>
<script>
export default {
  props: {
    type: {
      default: "text"
    },
    value: {
      type: String | Number,
      default: '',
      required: false,
    },
    name: {
      type: String | Number,
      required: true,
    },
    label: {
      type: String | Number,
    },
    placeholder: {
      type: String | Number,
      default: ''
    },
    required: {
      type: Boolean | Number | Object, // null is an object
      default: true
    },
    disabled: {
      default: false,
    },
    debounce: {
      default: false,
    },
    debounceSettings: {
      default: () => ({
        param: 'name',
        name: 'name',
        label: 'name',
        extra_params: {},
        route_name: null,
        // route_param: null,
      }),
    },

    form: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mouseOn: false,
      searching: false,
      duplicates: [],
    }
  },
  created() {
    this.searchDebounced = _.debounce(() => this.search(), this.SEARCH_DEBOUNCE_MS)
  },
  methods: {
    emitValue(value) {
      this.$emit('input', value)
    },
    search() {
      if (!this.debounce) return;

      if (!this.value.length) {
        this.duplicates = []
        return
      }

      let dbParams = {
        ..._.get(this.debounceSettings, 'extra_params', {}),
      }
      dbParams[this.debounceSettings.param] = this.value
      this.searching = true
      this.$axios.get(this.debounceSettings.url, {
        params: {
          ...dbParams,
        }
      })
          .then(({data}) => {
            this.duplicates = data.data
            this.$nextTick(() => {
              $(".duplicates").unmark()
              $(".duplicates").mark(this.value);
            })
          })
          .catch(err => this.toastLaraValidation(err))
          .finally(() => this.searching = false)
    },
    mouseEnter(){
      this.mouseOn = true
    },
    mouseLeave(){
      this.mouseOn = false
    },
  },
}
</script>
